import React, { Component } from 'react';
import {AppBar, Toolbar, Grid, withStyles, Hidden,IconButton, Drawer,List,Divider} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import logo from './logo.svg';
import Navbar from './navbar.js';
import {Link} from 'react-router-dom';


const styles = {
  appLogo:{
    animation: 'App-logo-spin infinite 20s linear',
    height: '60px',
    marginLeft: '-24px',
  },
  list: {
    width: 250,
  },

  navList:{
    display:'inherit',
    height: '64px',
  },
  sideBar:{
    lineHeight:'30px',
    width:'50vh',
    paddingTop:'5px'
  }
} 





class Header extends Component{
    
    constructor(props) {
      super(props);
      this.state = {
        showMenuDrawer : false,
      }
    }

    toggleDrawer = (isDrawerOpen) => {    
      this.setState({
        showMenuDrawer: isDrawerOpen,
      });
    };

    render(){
      const { classes } = this.props;
      return(
        <AppBar position="static">
          <Toolbar>
            <Grid container direction="row" justify="space-between" alignItems="center">
              <Grid item>
                <Link to="/">
                  <img src={logo} className={classes.appLogo} alt="logo" />
                </Link> 
              </Grid>
              
              <Grid item className={classes.navList}>
                <Hidden only="xs"> <Navbar /> </Hidden>
                <Hidden smUp>
                  <IconButton style={{display: 'flex',alignSelf: 'center'}} color="inherit" aria-label="Menu" onClick={()=>this.toggleDrawer(true)}>
                    <MenuIcon />
                  </IconButton>  
                  <Drawer anchor="right" open={this.state.showMenuDrawer} onClose={()=>this.toggleDrawer(false)}>
                      <div className={classes.sideBar}
                        tabIndex={0}
                        role="button"
                        onClick={()=>this.toggleDrawer(false)}
                        onKeyDown={()=>this.toggleDrawer(false)}
                      >
                        <Navbar />
                      </div>
                  </Drawer> 
                </Hidden>       
              </Grid>
             
            </Grid> 
            
          </Toolbar>
        </AppBar>
      );
    }


}


export default withStyles(styles)(Header);





// WEBPACK FOOTER //
// ./src/component/layouts/header.js